__webpack_require__.p = "/demos/site-card-react/";